var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451 260.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e97f6;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#dce0df;stroke-linejoin:round;}.cls-2{fill:#2a56c6;}.cls-3{fill:#00796b;}.cls-4{fill:#3367d6;}.cls-5{fill:#26a69a;}.cls-6{fill:#9c27b0;}.cls-7{fill:#6a1b9a;}.cls-8{fill:#00695c;}.cls-9{fill:#ea80fc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JAX Light Stroke") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.5 130.4 25.5 173.71 75.5 173.71 100.5 130.4 50.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.5 217.01 25.5 173.71 75.5 173.71 50.5 217.01 0.5 217.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "125.5 173.71 75.5 173.71 50.5 217.01 100.5 217.01 125.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.5 173.71 125.5 173.71 100.5 217.01 150.5 217.01 175.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "150.5 130.4 125.5 173.71 175.5 173.71 200.5 130.4 150.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.5 87.1 150.5 130.4 200.5 130.4 225.5 87.1 175.5 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.5 43.8 175.5 87.1 225.5 87.1 250.5 43.8 200.5 43.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225.5 0.5 200.5 43.8 250.5 43.8 275.5 0.5 225.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.5 217.01 25.5 260.31 75.5 260.31 50.5 217.01 0.5 217.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.5 260.31 75.5 260.31 50.5 217.01 100.5 217.01 125.5 260.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.5 260.31 125.5 260.31 100.5 217.01 150.5 217.01 175.5 260.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "200.5 217.01 175.5 173.71 150.5 217.01 175.5 260.31 200.5 217.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.5 130.4 225.5 87.1 200.5 130.4 250.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.5 43.8 225.5 87.1 250.5 130.4 275.5 87.1 250.5 43.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "125.5 173.71 100.5 130.4 75.5 173.71 125.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "250.5 130.4 200.5 130.4 175.5 173.71 225.5 173.71 250.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "300.5 130.4 250.5 130.4 225.5 173.71 275.5 173.71 300.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "350.5 43.8 325.5 0.5 300.5 43.8 325.5 87.1 350.5 43.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "375.5 87.1 350.5 43.8 325.5 87.1 350.5 130.4 375.5 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "400.5 130.4 375.5 87.1 350.5 130.4 375.5 173.71 400.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.5 173.71 400.5 130.4 375.5 173.71 400.5 217.01 425.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "450.5 217.01 425.5 173.71 400.5 217.01 425.5 260.31 450.5 217.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.5 0.5 400.5 43.8 425.5 87.1 450.5 43.8 425.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "375.5 87.1 400.5 43.8 425.5 87.1 400.5 130.4 375.5 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "350.5 130.4 325.5 173.71 350.5 217.01 375.5 173.71 350.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "325.5 260.31 300.5 217.01 325.5 173.71 350.5 217.01 325.5 260.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "275.5 260.31 250.5 217.01 300.5 217.01 325.5 260.31 275.5 260.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "225.5 173.71 175.5 173.71 200.5 217.01 250.5 217.01 225.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "275.5 173.71 225.5 173.71 250.5 217.01 275.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "275.5 87.1 300.5 130.4 350.5 130.4 325.5 87.1 275.5 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "300.5 43.8 250.5 43.8 275.5 87.1 325.5 87.1 300.5 43.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "425.5 260.31 400.5 217.01 350.5 217.01 375.5 260.31 425.5 260.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "375.5 173.71 350.5 217.01 400.5 217.01 375.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "325.5 0.5 275.5 0.5 250.5 43.8 300.5 43.8 325.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "325.5 173.71 275.5 173.71 250.5 217.01 300.5 217.01 325.5 173.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "350.5 130.4 300.5 130.4 275.5 173.71 325.5 173.71 350.5 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "425.5 0.5 375.5 0.5 350.5 43.8 400.5 43.8 425.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "375.5 87.1 350.5 43.8 400.5 43.8 375.5 87.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJax);
export default __webpack_public_path__ + "static/media/jax.909f01c3c092543fa0fa1dd6fd3f369c.svg";
export { ForwardRef as ReactComponent };